<template>
  <div class="container">
    <div class="form-container">
      <div class="signin-signup">
        <h3 class="title" style="text-align: center">
          {{ $t('login.title') }}
        </h3>
        <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="sign-in-form" auto-complete="on" label-position="left">
          <el-form-item prop="username">
            <el-input
              v-model="loginForm.username"
              :placeholder="$t('login.username')"
              prefix-icon="fa fa-user"
              name="username"
              type="text"
            />
          </el-form-item>

          <el-form-item prop="password">
            <el-input
              v-model="loginForm.password"
              :type="passwordType"
              :placeholder="$t('login.password')"
              name="password"
              @keyup.enter.native="handleLogin"
              prefix-icon="fa fa-lock"
              :show-password=true
            />
          </el-form-item>

          <el-form-item prop="captcha">
            <el-input
              v-model="loginForm.captcha"
              :placeholder="$t('login.captcha')"
              name="captcha"
              prefix-icon="fa fa-key"
              style="width: 50%;margin-right: 1rem;"
            />
            <img class="captcha" :src="(baseApi ? baseApi : '') + captchaSrc" @click="captcha" style="position: absolute;border: 1px solid #aaa;border-radius: 5px"/>
          </el-form-item>
          <el-form-item>
            <el-button :loading="loading" type="primary" class="btn" style="font-size: 16px" @click.native.prevent="handleLogin">
              {{ $t('login.logIn') }}
            </el-button>
          </el-form-item>

        </el-form>
      </div>
    </div>
    <div class="panels-container">
      <div class="panel left-panel">
        <div class="content">
          <span style="font-size: 56px;font-weight:500;margin:0 2px;font-family: '微软雅黑'">万物互联</span>
          <p style="padding:0;margin:0;font-size: 15px;font-weight:500;font-family: '微软雅黑'">IOT物联网开放系统 开放 互联 共享</p>
        </div>
        <img :src="img" class="image" alt="" />
      </div>
    </div>
<!--    <div class="beian">-->
<!--      <span><a href="https://beian.miit.gov.cn/#/Integrated/index" style="color: white">粤ICP备19084741号</a></span>-->
<!--    </div>-->
  </div>
</template>

<script>

export default {
  name: 'Login',
  data () {
    // const validateUsername = (rule, value, callback) => {
    //   if (!isvalidUsername(value)) {
    //     callback(new Error('Please enter the correct user name'))
    //   } else {
    //     callback()
    //   }
    // }
    // const validatePassword = (rule, value, callback) => {
    //   if (value.length < 6) {
    //     callback(new Error('The password can not be less than 6 digits'))
    //   } else {
    //     callback()
    //   }
    // }
    return {
      img: require('../../../static/images/login.png'),
      img1: require('../../../static/images/log.svg'),
      loginForm: {
        username: '',
        password: '',
        captcha: ''
      },
      loginRules: {
        username: [{ required: true, message: '用户名不能为空' }],
        password: [{ required: true, message: '密码不能为空' }],
        captcha: [{ required: true, message: '验证码不能为空' }]
      },
      passwordType: 'password',
      loading: false,
      showDialog: false,
      redirect: undefined,
      baseApi: process.env.BASE_API,
      captchaSrc: '/auth/api/auth/captcha'
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  methods: {
    showPwd () {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
    },
    handleLogin () {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('LoginByUsername', this.loginForm).then(() => {
            this.loading = false
            this.$router.push({ path: this.redirect || '/' })
          }).catch(() => {
            this.loading = false
            this.captchaSrc = '/auth/api/auth/captcha?' + Math.random()
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    captcha () {
      this.captchaSrc = '/auth/api/auth/captcha?' + Math.random()
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */
//.el-input__inner {
//  box-shadow: inset 0 0 0 1000px #fff!important;
//}
.sign-in-form .el-input__inner {
  text-indent: 1rem !important;
  height: 55px !important;
  background-color: #fff !important;;
  border-radius: 5px !important;
  border: 1px solid #aaa !important;
  font-size: 15px !important;
  //font-weight: 500 !important;
}
$bg:#283443;
$light_gray:#eee;
$cursor: #fff;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input{
    color: $cursor;
    &::first-line {
      color: $light_gray;
    }
  }
}

/* reset element-ui css */
.login-container {
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;
    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: $light_gray;
      height: 47px;
      caret-color: $cursor;
      &:-webkit-autofill {
        -webkit-box-shadow: 0 0 0px 1000px $bg inset !important;
        -webkit-text-fill-color: $cursor !important;
      }
    }
  }
  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
  }
  .captcha {
    display: inline-block;
    margin-bottom: -18px;
    padding: 0px;
    height: 47px;
    line-height: 40px;
  }
}
</style>
<style rel="stylesheet/scss" lang="scss" scoped>
.show-pwd {
  position: absolute;
  right: 10px;
  top: 7px;
  font-size: 16px;
  color: #889aa4;
  cursor: pointer;
  user-select: none;
}
//@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@200;300;400;500;600;700;800&display=swap");

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

.container {
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  background: linear-gradient(0deg, #f0f2f5, #f0f2f5 80%);
  //background-color: #6bb5b9;
  //background-color: #96adbf;
}

.container::before {
  content: " ";
  position: absolute;
  width: 2000px;
  height: 2000px;
  border-radius: 50%;
  //background: linear-gradient(-100deg, #2481eb, #fff);
  top: -10%;
  right: 48%;
  transform: translateY(-50%);
  z-index: 6;
  transition: 1.8s ease-in-out;
}

.form-container {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.signin-signup {
  position: absolute;
  top: 50%;
  left: 90%;
  transform: translate(-100%, -50%);
  width: 30%;
  display: grid;
  grid-template-columns: 1fr;
  z-index: 1000;
  transition: 1s 0.7s ease-in-out;
}

.sign-in-form {
  position: relative;
  width: 100%;
  max-width: 100%;
  padding: 1rem 35px;
  margin: 0 auto;
  overflow: hidden;
  z-index: 2;
}
.title {
  font-size: 2.2rem;
  margin-bottom: 10px;
}

.btn {
  width: 150px;
  height: 49px;
  border: none;
  outline: none;
  cursor: pointer;
  text-transform: uppercase;
  margin: 10px 0;
  transition: 0.5s;
}

.social-text {
  padding: 0.7rem 0;
  font-size: 1rem;
}

.social-media {
  display: flex;
  justify-content: center;
}

.panels-container {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}

.panel {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-around;
  text-align: center;
  z-index: 7;
}
.left-panel {
  padding: 3rem 17% 2rem 12%;
  pointer-events: all;
}
.right-panel {
  pointer-events: none;
  padding: 3rem 12% 2rem 17%;
}
.panel .content {
  margin-right: 50%;
  margin-top: 10%;
  transition: 0.9s 0.6s ease-in-out;
}

.panel h3 {
  font-weight: 600;
  line-height: 1;
  font-size: 1.5rem;
}
.panel p {
  font-size: 0.95rem;
  padding: 0.7rem 0;
}
.btn.transparent {
  margin: 0;
  background: none;
  border: 2px solid #fff;
  width: 130px;
  height: 41px;
  font-weight: 600;
  font-size: 0.8rem;
}
.image {
  width: 100%;
  transition: 1.1s 0.4s ease-in-out;
}

.right-panel .content,
.right-panel .image {
  transform: translateX(800px);
}

/* Animation */
.container.sign-up-mode:before {
  transform: translate(100%, -50%);
  right: 52%;
}

.container.sign-up-mode .left-panel .image,
.container.sign-up-mode .left-panel .content {
  transform: translateX(-100px);
}
.container.sign-up-mode .right-panel .content,
.container.sign-up-mode .right-panel .image {
  transform: translateX(0px);
}
.container.sign-up-mode .left-panel {
  pointer-events: none;
}
.container.sign-up-mode .right-panel {
  pointer-events: all;
}
.container.sign-up-mode .signin-signup {
  left: 25%;
}

.container.sign-up-mode form.sign-in-form {
  z-index: 1;
  opacity: 0;
}
.container.sign-up-mode form.sign-up-form {
  z-index: 2;
  opacity: 1;
}

@media (max-width: 870px) {
  .container {
    min-height: 800px;
    height: 100vh;
  }

  .container::before {
    width: 1500px;
    height: 1500px;
    left: 30%;
    bottom: 68%;
    transform: translateX(-50%);
    right: initial;
    top: initial;
    transition: 2s ease-in-out;
  }
  .container.sign-up-mode:before {
    transform: translate(-50%, 100%);
    bottom: 32%;
    right: initial;
  }
  .signin-signup {
    width: 90%;
    left: 50%;
    top: 80%;
    transform: translate(-50%, -100%);
    transition: 1s 0.8s ease-in-out;
  }
  .panels-container {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 2fr 1fr;
  }
  .panel {
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    padding: 2.5rem 8%;
  }
  .panel .content {
    margin-right: 20%;
    margin-top: -110%;
    transition: 0.9s 0.8s ease-in-out;
  }
  .panel h3 {
    font-size: 1.2rem;
  }
  .panel p {
    font-size: 0.7rem;
    padding: 0.5rem 0;
  }
  .btn.transparent {
    width: 110px;
    height: 35px;
    font-size: 0.7rem;
  }
  .image {
    width: 200px;
    transition: 0.9s 0.6s ease-in-out;
  }
  .left-panel {
    grid-row: 1/4;
  }
  .right-panel {
    grid-row: 3/4;
  }

  .right-panel .content,
  .right-panel .image {
    transform: translateY(300px);
  }

  .container.sign-up-mode .left-panel .image,
  .container.sign-up-mode .left-panel .content {
    transform: translateY(-300px);
  }
  .container.sign-up-mode .signin-signup {
    top: 5%;
    transform: translate(-50%, 0);
    left: 50%;
  }
}

@media (max-width: 570px) {
  form {
    padding: 0 1.5rem;
  }
  .image {
    display: none;
  }
  .panel .content {
    margin-right: -5%;
    margin-top: -150%;
  }
  .container::before {
    bottom: 72%;
    left: 50%;
  }
  container.sign-up-mode::before {
    bottom: 28%;
    left: 50%;
  }
}

.beian{
  position: absolute;
  color: #f0f2f5;
  font-weight: bold;
  top: 95%;
  left: 40%;
  width: 45%;
  display: grid;
  grid-template-columns: 1fr;
  z-index: 1000;
  transition: 1s 0.7s ease-in-out;
}

</style>



// WEBPACK FOOTER //
// src/views/login/index.vue